export default {
	campaignCode: 'Kód kampaně',
	campaignName: 'Název kampaně',
	campaignWaveTitle: 'Detail kampaně',
	channel: 'Kanál vlny',
	clearSetup: 'Vymazat nastavení',
	communicationCode: 'Kód komunikace',
	communicationName: 'Název komunikace',
	contactCount: 'Počet kontaktů',
	descriptionTitle: 'Volný popis kampaně',
	materialsOrderTitle: 'Nominace, objednávka adresního materiálu a nastavení tisku',
	parametersTitle: 'Parametry kampaně',
	renderColumnsTitle: 'Zobrazené sloupce',
	sidebarTitle: 'Doplňující sloupce v kampani',
	status: 'Stav',
	startDate: 'Začátek kampaně',
	endDate: 'Konec kampaně',
	campaignType: 'Typ kampaně',
	waveNumber: 'Číslo vlny',
	productionPlan: 'Plán celkové produkce (Kč)',
	expectedReplacement: 'Očekávaná náhrada kmene (%)',
	expectedValue: 'PPK (Kč)',
	letterPrintedDate: 'Tisky',
	nominationDate: 'Nominace',
	addMatOrder: 'Objednávka',
	openLetterDate: 'Otevírací dopisy',
	orderEndDate: 'Do',
	orderStartDate: 'Od',
	description: 'Popis',
};
